import { Application, getATSPlatform, ScreeningQuestion } from '@mkp/application/models';
import { mapAuditDates } from '@mkp/shared/data-access';
import { toUUID } from '@mkp/shared/models';
import { ApplicationDto } from './application.dto';

export const mapApplicationDtoToModel = (dto: ApplicationDto): Application => ({
  ...dto,
  id: toUUID(dto.id),
  ...mapAuditDates(dto),
  platform: getATSPlatform(dto.platform),
  screeningQuestions: dto.screeningQuestions ? sortScreeningQuestions(dto.screeningQuestions) : [],
});

const sortScreeningQuestions = (screeningQuestions: ScreeningQuestion[]): ScreeningQuestion[] => [
  ...screeningQuestions.sort(({ index: index1 }, { index: index2 }) => index1 - index2),
];
